import { render, staticRenderFns } from "./MyTicket.vue?vue&type=template&id=468c6c5f"
import script from "./MyTicket.vue?vue&type=script&lang=js"
export * from "./MyTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports